export const TRANSACTION_EDIT_PERMISSION = 'payment.edit_transaction'
export const ORDER_IMMEDIATE_SEND_PERMISSION = 'order.immediate_send_callcenter'
export const ORDER_COPY_TO_CLIPBOARD_PERMISSION = 'order.copy_to_clipboard'
export const ORDER_EXPORT_PERMISSION = 'order.export'
export const ORDER_CHANGE_COMPLETED_PAYMENT = 'order.change_completed_payment'

export const ORDER_VIEW_PERMISSION = 'order.list'
export const TICKET_TIME_EDIT_PERMISSION = 'ticket-time.edit'
export const NOTES_LIST_PERMISSION = 'notes.list'
export const MONITORING_LIST_PERMISSION = 'monitoring.list'
export const ORDER_DEPARTMENT_VIEW_PERMISSION = 'order-department.list'
export const FOREMAN_VIEW_PERMISSION = 'foreman.list'
export const ROBOT_LIST_PERMISSION = 'robot.list'
export const STOP_LISTS_VIEW_PERMISSION = 'stop-lists.list'
export const PRINT_MANAGEMENT_VIEW_PERMISSION = 'print-management.list'
export const SHIFT_AND_REPORTS_VIEW_PERMISSION = 'shift-and-reports.list'
export const DISPATCHER_LISTS_VIEW_PERMISSION = 'dispatcher.list'
export const STAFF_ORDER_EDIT_PERMISSION = 'staff-order.edit'
export const NOTIFICATIONS_MUTE_PERMISSION = 'notifications.mute'

export const menuItems = [
    {
        key: 1,
        name: 'Реестр заказов',
        to: '/orders',
        permission: ORDER_VIEW_PERMISSION,
    },
    {
        key: 2,
        name: 'Диспетчер',
        to: '/dispatcher',
        permission: DISPATCHER_LISTS_VIEW_PERMISSION,
    },
    {
        key: 3,
        name: 'Тикет Тайм',
        to: '/ticket-time',
        permission: TICKET_TIME_EDIT_PERMISSION,
    },
    {
        key: 4,
        name: 'Примечание',
        to: '/division-notes',
        permission: NOTES_LIST_PERMISSION,
    },
    {
        key: 5,
        name: 'Мониторинг',
        to: '/monitoring',
        permission: MONITORING_LIST_PERMISSION,
    },
    {
        key: 6,
        name: 'Заказы ресторанов',
        to: '/orders-department',
        permission: ORDER_DEPARTMENT_VIEW_PERMISSION,
    },
    {
        key: 7,
        name: 'Заказы цехов',
        to: '/foreman',
        permission: FOREMAN_VIEW_PERMISSION,
    },
    {
        key: 8,
        name: 'Авто-валидация',
        to: '/robot',
        permission: ROBOT_LIST_PERMISSION,
    },
    {
        key: 9,
        name: 'Каталог блюд',
        permission: [
            STOP_LISTS_VIEW_PERMISSION,
            PRINT_MANAGEMENT_VIEW_PERMISSION,
        ],
        children: [
            {
                key: '9-1',
                name: 'Управление печатью',
                to: '/menu-management/print',
                permission: PRINT_MANAGEMENT_VIEW_PERMISSION,
            },
            {
                key: '9-2',
                name: 'Стоп-листы',
                to: '/menu-management/stop-lists',
                permission: STOP_LISTS_VIEW_PERMISSION,
            },
        ],
    },
    {
        key: 10,
        name: 'Смена и отчёты',
        to: '/shift-and-reports',
        permission: SHIFT_AND_REPORTS_VIEW_PERMISSION,
    },
]
